import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaTiktok, FaYoutube } from 'react-icons/fa';

const youtubeUrl = 'https://www.youtube.com/c/XipandzaMananga?sub_confirmation=1';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-4">
      <div className="max-w-7xl mx-auto px-6 flex flex-col gap-4 items-center justify-between sm:flex-row sm:items-start">
        <div className="text-center sm:text-left">
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Xipandza Mananga Travel Pty LTD. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-2 text-sm sm:justify-start">
            <a href="/privacy-policy.html" className="hover:text-white">
              Privacy Policy
            </a>
            <a href="/terms-of-use.html" className="hover:text-white">
              Terms of Use
            </a>
            <a href="/support" className="hover:text-white">
              Support
            </a>
          </div>
        </div>

        <div className="flex space-x-6 mt-1 sm:mt-0">
          <a href="https://www.facebook.com/xipandza" className="hover:text-white" target="_blank" rel="noopener noreferrer">
            <FaFacebook size={20} />
          </a>
          <a href="https://www.instagram.com/xipandza_mananga" className="hover:text-white" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={20} />
          </a>
          <a href="https://twitter.com/@xipandza" className="hover:text-white" target="_blank" rel="noopener noreferrer">
            <FaTwitter size={20} />
          </a>
          <a href="https://www.tiktok.com/@xipandza_mananga" className="hover:text-white" target="_blank" rel="noopener noreferrer">
            <FaTiktok size={20} />
          </a>
          <a
            href={youtubeUrl}
            className="hover:text-white"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Xipandza Mananga YouTube channel"
          >
            <FaYoutube size={20} />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
